const getters = {
  isInsider: (state, getters, rootState, rootGetters) => {
    if (rootGetters['root/userRole']) return !rootGetters['root/userRole'].some(role => ['qp_agency', 'qp_client', 'qp_reseller'].includes(role))
    return false
  }
}
export default {
  namespaced: true,
  getters
}
